<template>
  <div>
    <!-- Title -->
    <component
      :is="titleTag"
      v-if="title"
      :class="titleClass"
    >
      {{ title }}
    </component>

    <!-- Description -->
    <p
      v-if="description"
      :class="descriptionClass"
    >
      {{ description }}
    </p>

    <!-- Title Underline -->
    <div v-if="underline" class="tw-flex tw-items-center tw-mt-2">
      <div class="tw-w-16 tw-h-1 tw-bg-primary" />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    titleTag?: string;
    title?: string;
    description?: string;
    underline?: boolean;
    titleClass?: string;
    descriptionClass?: string;
  }>(),
  {
    titleTag: "h2",
    title: "",
    description: "",
    underline: false,
    titleClass: "tw-text-mb-title-1 lg:tw-text-dt-title-1",
    descriptionClass:
      "tw-mt-0 tw-mb-4 md:tw-mb-0 tw-text-mb-body lg:tw-text-dt-body tw-text-dark-gray",
  },
);
</script>
